define('lib/backbone/Backbone.Mixins.Transport',['require','underscore','lib/backbone/Backbone.Mixins.Transport.Rails','lib/backbone/Backbone.Mixins.Transport.API','lib/Podio.Config'],function (require) {

  var _ = require('underscore');
  var RailsTransport = require('lib/backbone/Backbone.Mixins.Transport.Rails');
  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');
  var podioConfig = require('lib/Podio.Config');

  return {
    _getAPIHostName: function() {
      return podioConfig.endpoints.apiProxy;
    },

    _getTransportObject: function(options) {
      if (options && options.useLegacyTransport) {
        return RailsTransport;
      }
      return this.useDirectAPIAccess ? APITransport : RailsTransport;
    },

    request: function(method, url, data, options) {
      return this._getTransportObject(options).request.apply(this, _.toArray(arguments));
    },

    sync: function() {
      return this._getTransportObject().sync.apply(this, _.toArray(arguments));
    }
  };
});

